import { RouteObject } from 'react-router-dom'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'

import Create from './components/Create'
import Detail from './components/Detail'
import Edit from './components/Edit'
import Home from './components/Home'
import PublicFeedback from './components/PublicFeedback'
import Templates from './components/Templates'

const TicketModule: RouteObject = {
    path: 'tickets',
    children: [
        {
            path: '',
            element: <Home />,
        },
        {
            path: 'templates',
            element: <Templates />,
        },
        {
            path: ':ticketID',
            element: <Detail />,
        },
        {
            path: ':ticketID/edit',
            element: <Edit />,
        },
        {
            path: 'new',
            element: <Create />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

// Public feedback page (no auth required)
const TicketFeedbackPublic: RouteObject = {
    path: 'feedback',
    children: [
        {
            path: ':token',
            element: <PublicFeedback />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default TicketModule
export { TicketFeedbackPublic }
